import { React, PT, Link } from '@gasbuddy/react';
import { Table } from 'semantic-ui-react';
import { BrandLogo, BrandDescription } from '..';

export const BrandTable = ({ brands = [] }) => {
  const brandRows = brands.map(brand => (
    <Table.Row key={brand.brand_id}>
      <Table.Cell>
        <BrandLogo brand={brand} size="Small" />
        {' '}
      </Table.Cell>
      <Table.Cell><Link to={`brand/${brand.brand_id}`}>{brand.name}</Link></Table.Cell>
      <Table.Cell>{brand.logo_version}</Table.Cell>
      <Table.Cell><BrandDescription brand={brand} /></Table.Cell>
    </Table.Row>
  ));

  return (
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Logo</Table.HeaderCell>
          <Table.HeaderCell>Name</Table.HeaderCell>
          <Table.HeaderCell>LogoVersion</Table.HeaderCell>
          <Table.HeaderCell>Description</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {brandRows}
      </Table.Body>
    </Table>
  );
};

BrandTable.defaultProps = {
  brands: [],
};

BrandTable.propTypes = {
  brands: PT.arrayOf(PT.shape(
    {
      brand_id: PT.number,
      name: PT.string,
      logo_version: PT.number,
      is_cstore: PT.boolean,
      is_fuel: PT.boolean,
      allow_brand_sharing: PT.boolean,
    },
  )),
};
